var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1017 0H0.898485C0.402213 0 0 0.454652 0 1.01563C0 3.84391 1.07257 6.54405 2.94272 8.42316L6.87763 12.3766C7.55991 13.0621 7.95125 14.0472 7.95125 15.0793V24.9832C7.95125 25.7926 8.75146 26.2778 9.34793 25.8281L14.6488 21.8336C14.8987 21.6452 15.0489 21.3282 15.0489 20.9886V15.0793C15.0489 14.0472 15.4403 13.0621 16.1225 12.3766L20.0573 8.42316C21.9274 6.54405 23 3.84391 23 1.01563C23 0.454652 22.5978 0 22.1017 0ZM18.8635 6.90488L14.9287 10.8585C13.8632 11.9293 13.252 13.4676 13.252 15.0791V20.4451L9.74804 23.0855V15.0793C9.74804 13.4676 9.13683 11.9293 8.07128 10.8585L4.13654 6.90508C2.8755 5.63772 2.07055 3.90124 1.85506 2.03106H21.1449C20.9294 3.90124 20.1247 5.63772 18.8635 6.90488Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.96116ee0.svg";
export { ForwardRef as ReactComponent };